  <script>
    import { user } from '../store.js';
    import { Role } from '../constants.js';

    
    // TODO if admin is logged in, set correct 
    let selected = 'alerts';

    if ($user.role === Role.ADMIN ) {
      selected = 'accounts';
    }

    let hash = '#/app/alert';

    const toggle = (topSelected) => {
      selected = topSelected;
    }
  
    window.addEventListener("hashchange", () => {
      hash = location.hash;
    }, false);

  </script>
  <nav class="sidebar sidebar-offcanvas" id="sidebar">
    <ul class="nav">
      {#if $user.role === Role.ADMIN}
        <li class="nav-item" class:active={selected === 'accounts'}>
          <div class="nav-link" aria-expanded={selected === 'accounts'} class:collapsed={selected !== 'accounts'} on:click|stopPropagation={() => toggle('accounts')}>
            <i class="mdi mdi-account menu-icon"></i>
            <span class="menu-title">Customers</span>
            <i class="menu-arrow"></i>
          </div>
          <div class="collapse" class:show={selected === 'accounts'}>
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <a class="nav-link" class:active={hash === '#/admin/accounts'} href="#/admin/accounts">All Customers</a>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item" class:active={selected === 'reports'}>
          <div class="nav-link" aria-expanded={selected === 'reports'} class:collapsed={selected !== 'reports'} on:click|stopPropagation={() => toggle('reports')}>
            <i class="mdi mdi-account menu-icon"></i>
            <span class="menu-title">Reports</span>
            <i class="menu-arrow"></i>
          </div>
          <div class="collapse" class:show={selected === 'reports'}>
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <a class="nav-link" class:active={hash === '#/admin/reports/alert-count-report'} href="#/admin/reports/alert-count-report">Alert Count Report</a>
              </li>
            </ul>
          </div>
        </li>
      {:else}
        <li class="nav-item" class:active={selected === 'residents'}>
          <div class="nav-link" aria-expanded={selected === 'residents'} class:collapsed={selected !== 'residents'} on:click|stopPropagation={() => toggle('residents')}>
            <i class="mdi mdi-account-multiple menu-icon"></i>
            <span class="menu-title">Residents</span>
            <i class="menu-arrow"></i>
          </div>
          <div class="collapse" class:show={selected === 'residents'}>
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <a class="nav-link" class:active={hash === '#/app/residents'} href="#/app/residents">All Residents</a>
              </li>
              <li class="nav-item"> 
                <a class="nav-link" class:active={hash === '#/app/residents/import'} href="#/app/residents/import">Import CSV</a>
              </li>
              <li class="nav-item"> 
                <a class="nav-link" class:active={hash === '#/app/residents/sync'} href="#/app/residents/sync">Sync UBMax</a>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item" class:active={selected === 'alerts'}>
          <div class="nav-link" aria-expanded={selected === 'alerts'} class:collapsed={selected !== 'alerts'} on:click|stopPropagation={() => toggle('alerts')}>
            <i class="mdi mdi-comment-alert menu-icon"></i>
            <span class="menu-title">Alerts</span>
            <i class="menu-arrow"></i>
          </div>
          <div class="collapse" class:show={selected === 'alerts'}>
            <ul class="nav flex-column sub-menu">
              <li class="nav-item"> 
                <a class="nav-link" class:active={hash === '#/app/alerts'} href="#/app/alerts">All Alerts</a>
              </li>
              <li class="nav-item"> 
                <a class="nav-link" class:active={hash === '#/app/alert'} href="#/app/alert">Create Alert</a>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item" class:active={selected === 'settings'}>
          <a class="nav-link" href="#/app/settings" on:click|stopPropagation={() => toggle('settings')}>
            <i class="mdi mdi-settings menu-icon"></i>
            <span class="menu-title">Settings</span>
          </a>
        </li>
      {/if}
    </ul>
  </nav>